import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bdaf6dde&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=bdaf6dde&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdaf6dde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdaf6dde')) {
      api.createRecord('bdaf6dde', component.options)
    } else {
      api.reload('bdaf6dde', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bdaf6dde&scoped=true", function () {
      api.rerender('bdaf6dde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/receipt/index.vue"
export default component.exports